import { AgChartOptions } from "ag-charts-community";

export type Series = AgChartOptions["series"];
